import core from '../../store/quincy/core';

export default {
  data() {
    return {};
  },
  mounted() {
    this.initCanvasEvents();
    this.$bus.$on('symptomsBody.modelLoaded', () =>
      setTimeout(() => this.onWindowResize(), 500)
    );
  },

  beforeUnmount() {
    this.destroyEventListeners2();
  },

  methods: {
    initCanvasEvents() {
      window.addEventListener('resize', this.onWindowResize, false);
      // document.getElementById('canvas-container').addEventListener( 'mousewheel', this.onDocumentMouseWheel, false );
    },

    destroyEventListeners2() {
      window.removeEventListener('resize', this.onWindowResize);
    },

    onDocumentMouseWheel(e) {
      e.preventDefault();
      return false;
    },

    onWindowResize() {
      const width = core.container.clientWidth;
      const height = core.container.clientHeight;

      core.camera.aspect = width / height;
      core.camera.updateProjectionMatrix();
      core.renderer.setSize(width, height);
      this.triggerRender();

      // core.positionObject(width, height);
    },

    positionObject(_width, _height) {
      // TODO: Fit object to canvas
      // var maxDim = Math.max(width, height);
      // var aspectRatio = width / height;
      // var distance = maxDim/ 2 /  aspectRatio / Math.tan(Math.PI * 30 / 360);
      // var fov = 2 * Math.atan( height / ( 2 * distance ) ) * ( 180 / Math.PI );
      // this.camera.fov = fov;
      // this.camera.updateProjectionMatrix();
      // var box = new THREE.Box3().setFromObject( this.object );
      // this.$debug(fov, this.camera.fov, distance, box.getSize());
      // this.camera.position.z = distance *-1;
    }
  }
};
